import React from "react";
import { Link } from "react-router-dom";

export default function MentionsLegales() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="page-mentions">
      <div className="overline text-accent">— Mentions légales</div>
      <h1 className="font-display font-bold text-4xl tracking-tighter mb-10">Mentions légales</h1>
      <p className="text-sm text-amber-700 font-mono mb-8">Projet non publié — à compléter après immatriculation et avant lancement</p>

      <div className="space-y-6 text-[15px] leading-relaxed">
        <section>
          <h2 className="font-display font-bold text-xl mb-2">Éditeur du site</h2>
          <p>
            <strong>MML — Plateforme Logistique</strong><br />
            [Forme juridique à compléter — SARL, SAS…]<br />
            [Adresse du siège social à compléter]<br />
            SIRET : [à compléter] · RCS : [à compléter]<br />
            Capital social : [à compléter] · N° TVA intracom. : [à compléter]<br />
            Directeur de la publication : [Nom du dirigeant]
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-xl mb-2">Contact</h2>
          <p>
            Général : [adresse email à valider]<br />
            Protection des données : [contact à valider]<br />
            Téléphone : [à compléter]
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-xl mb-2">Hébergement</h2>
          <p>
            Hébergeur, adresse et coordonnées : [à compléter selon l'infrastructure retenue]<br />
            Prestataire de paiement pressenti : Stripe [contrat et entité à confirmer]
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-xl mb-2">Propriété intellectuelle</h2>
          <p>Les droits sur le site, le code, le nom de domaine et les créations devront être cédés ou apportés à la future société avant le lancement.</p>
        </section>
        <section>
          <h2 className="font-display font-bold text-xl mb-2">Médiation de la consommation</h2>
          <p>Conformément à l'art. L 612-1 du Code de la consommation : <strong>[Coordonnées du médiateur à compléter]</strong>.</p>
        </section>
        <section className="pt-4 border-t border-neutral-200">
          <p className="text-sm text-neutral-500">
            Voir aussi : <Link to="/privacy" className="text-[#1F4032] underline">Politique de confidentialité</Link> · <Link to="/legal/cgu" className="text-[#1F4032] underline">CGU</Link>
          </p>
        </section>
      </div>
    </div>
  );
}
